// extracted by css-extract-rspack-plugin
export default {"alertBox":"ProjectHourBillingPreview_alertBox__uMz7N","warning":"ProjectHourBillingPreview_warning__my6iO","pdfPreview":"ProjectHourBillingPreview_pdfPreview__OVeq5"};